<template>
    <b-container class="module basic-info" fluid>
        <b-row>
            <b-col class="banners">
                <img v-for="(img, index) in basicInfo.banners" :key="index" :src="img.imgSrc" alt="">
            </b-col>
            <b-col class="basic">
                <vue-sticky top="101px">
                    <b-row class="product-name-price">
                        <b-col class="product-name" cols="8">{{basicInfo.name}}</b-col>
                        <b-col class="product-price" cols="4">{{basicInfo.price}}</b-col>
                    </b-row>

                    <b-row class="product-series">
                        <b-col class="series-name" cols="8">
                            <div class="cnName" v-if="basicInfo.series">{{basicInfo.series.name}} <span class="label">{{basicInfo.series.label}}</span>
                            </div>
                            <div class="enName" v-if="basicInfo.series">{{basicInfo.series.alias}}</div>
                        </b-col>
                        <b-col class="series-share" cols="4">
                            {{basicInfo.tags}}
                        </b-col>
                    </b-row>

                    <b-row class="product-desc" v-if="basicInfo.desc">
                        <b-col>
                            {{basicInfo.desc}}
                        </b-col>
                    </b-row>

                    <b-row class="product-style" v-if="basicInfo.style">
                        <b-col>
                            <div class="style-title">
                                {{basicInfo.style.title}}
                            </div>
                            <ScrollList class="style" :control="true" :items="basicInfo.style.items" :cols=3
                                        @click="changeProduct"></ScrollList>
                        </b-col>
                    </b-row>

                    <b-row class="product-buy-btn" v-if="basicInfo.btn">
                        <b-col>
                            <b-button class="btn dark">{{basicInfo.btn.text}}</b-button>
                        </b-col>
                    </b-row>

                    <b-row class="product-miniprogram" v-if="basicInfo.miniprogram">
                        <b-col cols="6">
                            <div class="minprogram-title">{{basicInfo.miniprogram.title}}</div>
                            <img :src="basicInfo.miniprogram.imgSrc" alt="">
                        </b-col>

                        <b-col cols="6">
                            <div v-if="basicInfo.display_properties.properties">
                                <div class="minprogram-title">{{basicInfo.display_properties.title}}</div>
                                <b-row class="product-property" v-for="(property, index) in basicInfo.display_properties.properties"
                                       :key="index">
                                    <b-col>
                                        <b-row v-if="lang === 'cn'">
                                            <b-col class="property-name" cols="4">
                                                {{property.title}}
                                            </b-col>
                                            <b-col class="property-value" cols="8">
                                                {{property.value}}
                                            </b-col>
                                        </b-row>
                                        <b-row v-else>
                                            <b-col class="property-name" cols="5">
                                                {{property.title}}
                                            </b-col>
                                            <b-col class="property-value" cols="7">
                                                {{property.value}}
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                </vue-sticky>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import VueSticky from '../../common/VueStickey'
    import images from '../../../assets/img'
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'basicInfo',
        data() {
            return {
                share: images.share,
                lang: localStorage.getItem('lang') || 'cn'
            }
        },
        props: {
            basicInfo: Object,
        },
        components: {
            ScrollList,
            VueSticky,
        },
        methods: {
            changeProduct(slug) {
                this.$emit('changeProduct', slug)
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .basic {
            .product-name-price {
                .product-name, .product-price {
                    font-size: 13px !important;
                }
            }

            .enName {
                //font-family: SourceHanSerifSC-Medium, serif !important;
                font-family: source-han-serif-sc, serif !important;
            }

            .cnName {
                font-size: 26px !important;
                font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;

                .label {
                    font-family: Montserrat-Light, Helvetica, Arial, sans-serif !important;
                }
            }

            .style-title, .minprogram-title {
                font-size: 12px !important;
            }

            .product-property {
                .row {
                    white-space: nowrap;

                    .property-name {
                        font-size: 8px !important;
                    }

                    .property-value {
                        font-size: 8px !important;
                    }
                }
            }
        }
    }

    .basic-info {
        .row {
            margin: 0;
        }

        .col {
            padding: 0;
            text-align: left;
        }

        .banners {
            flex: 0 0 70%;
            width: 70%;

            img {
                width: 100%;

                &:nth-child(n+2) {
                    margin-top: 10px;
                }
            }
        }

        .basic {
            flex: 0 0 30%;
            width: 30%;
            padding-left: @page-padding;

            .product-name-price {
                margin-top: 25px;

                .product-name, .product-price {
                    padding: 0;
                    font-size: 15px;
                    line-height: 18px;
                    text-align: left;
                }

                .product-price {
                    text-align: right;
                }
            }

            .product-series {
                margin-top: 8px;

                .series-name {
                    padding: 0;
                    text-align: left;

                    .cnName {
                        margin-left: -1px;
                        font-size: 28px;
                        line-height: 36px;
                        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                        white-space: nowrap;

                        .label {
                            font-family: NotoSansKR-Regular, Helvetica, Arial, sans-serif;
                        }
                    }

                    .enName {
                        margin-top: 8px;
                        font-size: 14px;
                        line-height: 21px;
                        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                    }
                }

                .series-share {
                    padding: 0;
                    text-align: right;
                    font-size: 13px;
                    line-height: 36px;
                    white-space: nowrap;

                    img {
                        width: 24px;
                    }
                }
            }

            .product-desc {
                margin-top: 25px;
                font-size: 12px;
                line-height: 22px;

                .col {
                    text-align: justify;
                }
            }

            .product-property {
                font-size: 14px;
                line-height: 28px;

                &:nth-child(2) {
                    margin-top: 18px;
                }

                &:nth-child(n + 3) {
                    margin-top: 8px;
                }

                .row {
                    white-space: nowrap;

                    .property-name {
                        display: inline-block;
                        padding: 0;
                        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                        font-size: 11px;
                        line-height: 15px;
                    }

                    .property-value {
                        display: inline-block;
                        padding: 0;
                        font-size: 11px;
                        line-height: 15px;
                        white-space: normal;

                    }
                }
            }

            .product-style {
                margin-top: 30px;

                .style-title {
                    font-size: 14px;
                    line-height: 18px;
                    margin-bottom: 8px;
                }

                .list {
                    margin: 0;
                    padding: 0;
                    overflow: visible !important;

                    /deep/ .list-item {
                        margin-left: 0 !important;
                        .col {
                            padding: 0;
                            margin: 0 2px;
                            max-width: 102px;
                            box-sizing: border-box;
                            flex: 0 0 23% !important;
                        }
                    }

                    /deep/ .card {
                        min-width: auto !important;
                    }

                    /deep/ .card-body {
                        display: none;
                    }

                    /deep/ .control {
                        top: 50% !important;
                        width: 20px;
                        height: 20px;

                        &.left {
                            left: -10px;
                        }

                        &.right {
                            right: -14px;
                        }
                    }
                }
            }

            .product-buy-btn {
                margin-top: 10px;

                .dark {
                    height: 51px;
                    font-size: 18px;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                    border-radius: 51px;
                    color: @primary-light-color;
                    background: @primary-dark-color;
                    border: none;
                }
            }

            .product-miniprogram {
                margin-top: 30px;

                .col-6 {
                    padding: 0;
                    &:nth-child(1) {
                        padding-right: 10px;
                    }

                    &:nth-child(2) {
                        padding-right: 10px;
                    }
                }

                .minprogram-title {
                    font-size: 14px;
                    line-height: 18px;
                }

                img {
                    width: 100%;
                    max-width: 160px;
                    margin-top: 15px;
                }
            }
        }
    }
</style>
